import React from "react";
import "./LoadingOverlay.css";

const LoadingOverlay = ({
  isVisible,
  progress = 0,
  message = "Loading...",
  showProgressBar = true,
}) => {
  if (!isVisible) return null;

  const progressPercentage = Math.round(progress);

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner">
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
        </div>
        <div className="loading-message">{message}</div>

        {showProgressBar && (
          <div className="loading-progress">
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: `${progressPercentage}%` }}
              >
                <div className="progress-bar-shine"></div>
              </div>
            </div>
            <div className="progress-value">{progressPercentage}%</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
